"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Debounce_1 = __importDefault(require("../../realtime-ceo/modules/components/Debounce"));
function LabelledInput(props) {
    const { type, debounce, onChange, label } = props, inputProps = __rest(props, ["type", "debounce", "onChange", "label"]);
    const getInput = () => {
        if (type == null) {
            return null;
        }
        if (debounce) {
            return (react_1.default.createElement(Debounce_1.default, Object.assign({ onChange: onChange, type: type }, inputProps)));
        }
        return (react_1.default.createElement("input", Object.assign({ onChange: e => onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value), type: type }, inputProps)));
    };
    const { id, name, children } = props;
    return (react_1.default.createElement("div", { className: "row LabelledInput" },
        react_1.default.createElement("div", { className: "LabelledInput-left" },
            react_1.default.createElement("label", { htmlFor: id }, label !== null && label !== void 0 ? label : name)),
        react_1.default.createElement("div", { className: "LabelledInput-right input-container" },
            getInput(),
            children)));
}
exports.default = LabelledInput;
